export default __webpack_public_path__ + "static/media/detail_big_11_7.2eea71c2.jpg";